//@ts-expect-error Untyped import
import { configureReport } from '../../configure';
//@ts-expect-error Untyped import
import { load } from '../../dataTypeDefinitions';
//@ts-expect-error Untyped import
import { isOnlySupportedViaBackendResolve } from '../../v2/reportingApi/isSupportedForBackendResolve';
import { findSupportedGeneratorAsync } from './generators';
import { Metrics } from '../../monitoring/Metrics';
import { DRILLDOWN, DRILLDOWN_TYPES } from '../../constants/trackingMetrics';
import { userInfo as getUserInfo } from '../../request/user-info';
export const generateDrilldownReport = (baseReport, keys, options = {}) => (isOnlySupportedViaBackendResolve(baseReport) ? Promise.resolve(baseReport) : configureReport(baseReport)).then(report => load(report.getIn(['config', 'dataType'])).then(dataTypeModule => {
  const fetchingGenerator = findSupportedGeneratorAsync(report, dataTypeModule, {
    checkColumnSupport: true,
    column: keys.get(-2)
  });
  return Promise.all([fetchingGenerator, getUserInfo()]).then(([generator, userInfo]) => {
    if (!generator) {
      return report;
    }
    const drilldownType = generator.trackingName || DRILLDOWN_TYPES.OTHER;
    Metrics.counter(DRILLDOWN, {
      drilldown_type: drilldownType
    }).increment();
    return generator.generate(report, keys, options, dataTypeModule, userInfo);
  });
}));